import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { axiosCacheInstance } from "../../../../axiosSetup";

export const getCountryList = createAsyncThunk(
    'document/getCountryList',
    async () => {
        try {
            const response = await axiosCacheInstance.get("/api/user-management/v1/country/getCountryDetailsByOdexActive?odexActive=Y");
            console.log("Country List Response:", response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching country list:", error);
            return [];
        }
    })();


export const getDocumentListByLinerAndCountry = createAsyncThunk(
    'document/getDocumentListByLinerAndCountry',
    async (params:{country:string, liner:string}) => {
        try {
            const response = await axiosInstance.get(`/api/master/v1/documentManager/getHelpDocumentListByLinerAndCountry?country=${params.country}&liner=${params.liner}`);
            const formattedData = response.data.map((item: any) => (
                {
                    "title": item?.moduleName,
                    "pdf": item?.docPath,
                    "video": item?.videoPath,
                    "language": item?.languageCode,
                    ...item
                }));
            console.log(formattedData,"<<formattedData")
            return formattedData?.sort((a: any, b: any) => a.sequenceNumber - b.sequenceNumber);
        } catch (error) {
            console.error("Error fetching upload document details:", error);
            return [];
        }
    });

export const getUploadDocDetails = createAsyncThunk(
    'document/getUploadDocDetails',
    async (id: number) => {
        try {
            const response = await axiosInstance.get(`/api/master/v1/documentManager/getHelpDocument?documentHelpId=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching upload document details:", error);
            return [];
        }
    });

export const getLinerList = createAsyncThunk(
    'document/getLinerList',
    async (payload: any) => {
        try {
            const response = await axiosInstance.get(`/api/edo-rest-v2/v2/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=ACTIVE_LINERS&linerId=&countryCode=${payload.partnerCountry}`);
            const options = response.data.map((item: any) => ({
                value: item.codeId,
                text: item.codeDesc,
            }));
            return options;
        } catch (error) {
            console.error("Error fetching country list:", error);
            return [];
        }
    });


export const getStatusList = createAsyncThunk(
    'document/getStatusList',
    async (payload: any) => {
        try {
            const response = await axiosInstance.get(`/api/edo-rest-v2/v2/mstCode/getMstCodeListByTypeAndLanguage?language=EN&codeType=HELP_DOCUMENT_STATUS&linerId=${payload.linerId}&countryCode=${payload.partnerCountry}`);
            const options = response.data.map((item: any) => ({
                value: item.codeId,
                text: item.codeDesc,
            }));
            return options;
        } catch (error) {
            console.error("Error fetching country list:", error);
            return [];
        }
    });

export const getLanguageList = createAsyncThunk(
    'document/getLanguageList',
    async (payload: any) => {
        try {
            const response = await axiosInstance.get(`/api/edo-rest-v2/v2/mstCode/getMstCodeListByTypeAndLanguage?language=&codeType=LANGUAGE_TYPE&linerId=${payload.selectedLinerId}&countryCode=${payload.partnerCountry}`);
            const options = response.data.map((item: any) => ({
                value: item.codeLang,
                text: item.codeDesc,
            }));
            console.log(options,"<<getLanguageList")
            return options;
        } catch (error) {
            console.error("Error fetching country list:", error);
            return [];
        }
    });


export const submitDoc = createAsyncThunk(
    'document/submitDoc',
    async (payload: any) => {
        try {
            const response = await axiosInstance.post(`/api/master/v1/documentManager/submitOrUpdateHelpDocument`, payload);
            return response.data;
        } catch (error) {
            console.error("Error submitting document:", error);
            return [];
        }
    });